export default {"src":"/_next/static/media/dol-online.2add7be3.svg","height":32,"width":65};